export default __webpack_public_path__ + "static/media/LightCloud.a15b6ea9.png";